import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import PhotoFilter from '@material-ui/icons/PhotoFilter';
import { MenuItem } from 'types/global';

type UsersProps = {
	selected: MenuItem;
	onSelect(event?: React.MouseEvent<HTMLDivElement, MouseEvent>, index?: MenuItem): void;
};

export default function LevelMaps({ selected, onSelect }: UsersProps) {
	const { t } = useTranslation();

	return (
		<ListItem
			button
			component={Link}
			to="/levelMap"
			selected={selected === MenuItem.LevelMaps}
			onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent> | any) => onSelect(event, MenuItem.LevelMaps)}
		>
			<ListItemIcon>
				<PhotoFilter />
			</ListItemIcon>
			<ListItemText primary={t('levelMaps:levelMap_plural')} />
		</ListItem>
	);
}
